import { cn } from 'design-system/react';

import type { SimulationState } from '../../client';

type BadgeState = SimulationState | 'loading';

function getStateColor(state: BadgeState): string {
  switch (state) {
    case 'not-started':
      return 'bg-state-not-started';
    case 'running':
      return 'bg-state-running';
    case 'paused':
      return 'bg-state-paused text-text-primary';
    case 'finished':
      return 'bg-state-finished';
    case 'loading':
      return 'bg-primary-500';
    default:
      return 'bg-state-not-started';
  }
}

function getStateDisplay(state: BadgeState): string {
  switch (state) {
    case 'not-started':
      return 'Not Started';
    case 'running':
      return 'Running';
    case 'paused':
      return 'Paused';
    case 'finished':
      return 'Finished';
    case 'loading':
      return 'Loading...';
    default:
      return state;
  }
}

export function SimulationStateBadge({ state }: { state: BadgeState }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold text-white',
        getStateColor(state),
      )}
    >
      {getStateDisplay(state)}
    </span>
  );
}
